import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { searchInternshipsRoutePathByLocale } from '#/modules/search/routing/search.route-paths';
import type { searchInternshipsRouteReference } from '#/modules/search/routing/search.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { SearchInternshipsPageLoadable } from './SearchInternshipsPageLoadable';

export const handle = {
  urlByLocale: searchInternshipsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'INTERNSHIP',
  hideFooterDivider: true,
  searchFromPageType: 'SEARCH',
  showDesktopSearch: true,
  isSearchPage: true,
  showSearchRefinements: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchInternshipsRouteReference>,
) {
  await SearchInternshipsPageLoadable.load();
}

export default function SearchInternshipsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule
      title={
        /* TRANSLATORS: internship search page title */
        i18n('Best Internships Near You, Remote Internships')
      }
    >
      <SearchInternshipsPageLoadable />
    </RouteModule>
  );
}
